import { render, staticRenderFns } from "./areaNotFind.vue?vue&type=template&id=e47d81d4&scoped=true&"
import script from "./areaNotFind.vue?vue&type=script&lang=js&"
export * from "./areaNotFind.vue?vue&type=script&lang=js&"
import style0 from "./areaNotFind.vue?vue&type=style&index=0&id=e47d81d4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47d81d4",
  null
  
)

export default component.exports